import React, { useState } from "react";

import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

const UpdateReservation = ({ handleCloseDialog }) => {
  const [type, setType] = useState(null);
  const [recurringOption, setRecurringOption] = useState("");
  const [frequencyOption, setFrequencyOption] = useState("");

  const handleRecurringChange = (event, newValue) => {
    if (newValue !== null) {
      setRecurringOption(newValue);
    }
  };

  const handleFrequencyChange = (event, newValue) => {
    if (newValue !== null) {
      setFrequencyOption(newValue);
    }
  };

  return (
    <Box>
      <Grid container spacing={1} mt={1} justifyContent="center">
        <Grid item xs={12}>
          <Autocomplete
            options={["Sponsor a Day", "Sponsor Lifetime"]}
            value={type}
            onChange={(event, newValue) => setType(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Package" fullWidth />
            )}
          />
        </Grid>
        <Grid item xs={12} mt={2}>
          <Card align="center">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar sx={{}} />
            </LocalizationProvider>
            <ToggleButtonGroup
              color="secondary"
              exclusive
              value={recurringOption}
              onChange={handleRecurringChange}
              aria-label="Recurring or One-Time"
              sx={{ mb: 3, justifyContent: "center", mr: 2 }}
            >
              <ToggleButton value="recurring">Recurring</ToggleButton>
              <ToggleButton value="one-time">One-Time</ToggleButton>
            </ToggleButtonGroup>

            {/* Monthly or Yearly Toggle Button */}
            <ToggleButtonGroup
              color="secondary"
              exclusive
              value={frequencyOption}
              onChange={handleFrequencyChange}
              aria-label="Monthly or Yearly"
              sx={{ mb: 3, justifyContent: "center" }}
            >
              <ToggleButton value="monthly">Monthly</ToggleButton>
              <ToggleButton value="yearly">Yearly</ToggleButton>
            </ToggleButtonGroup>

            {/* Check Availability Button */}
            <Button
              variant="outlined"
              sx={{
                //   backgroundColor: "#8B2757",
                color: "#8B2757",
                borderRadius: 1,
                borderColor: "#8B2757",
                textTransform: "none",
                fontWeight: "bold",
                mb: 5,
                width: "23.5rem",
              }}
              onClick={() => {
                console.log(
                  `Check Availability clicked for ${recurringOption} - ${frequencyOption}`
                );
              }}
            >
              Check Availability for Recurring
            </Button>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="flex-end"
          spacing={1}
          mt={1}
        >
          <Grid item>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCloseDialog}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="secondary" type="submit">
              Update
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdateReservation;
